import { Link } from "react-router-dom";
import { ArrowRight, Phone } from "lucide-react";
import Seo from "@/components/Seo";
import { PageHero, Reveal } from "@/components/Primitives";
import ProofStrip from "@/components/ProofStrip";
import { SERVICES, BUSINESS } from "@/data/site";

export default function Services() {
  return (
    <>
      <Seo
        title="Services"
        description="Explore Mom's Best Friend Sitters services across DFW: babysitting, hotel & resort child care, church care, special events, overnight & newborn care, and Pop-In PA."
        breadcrumbs={[{ name: "Home", item: "/" }, { name: "Services", item: "/services" }]}
      />
      <PageHero
        overline="Our services"
        title="Trusted care for every family need"
        subtitle="Six dedicated services across the Dallas–Fort Worth metroplex — each staffed by 11-step screened, CPR-certified caregivers."
      />
      <ProofStrip />

      <section className="container-mbf py-20 md:py-28">
        <div className="grid md:grid-cols-2 gap-8">
          {SERVICES.map((s, i) => (
            <Reveal key={s.id} delay={i * 0.05}>
              <div className="card-warm p-8 md:p-10 h-full flex flex-col" data-testid={`services-card-${s.id}`}>
                <span className="overline mb-3">{s.tagline}</span>
                <h2 className="font-serif text-2xl md:text-3xl text-espresso mb-3">{s.name}</h2>
                <p className="text-base text-stoneish leading-relaxed mb-5">{s.short}</p>
                <ul className="space-y-2 mb-7">
                  {s.features.map((f) => (
                    <li key={f} className="flex items-center gap-2.5 text-sm text-espresso">
                      <span className="w-1.5 h-1.5 rounded-full bg-terracotta shrink-0" /> {f}
                    </li>
                  ))}
                </ul>
                <div className="mt-auto flex flex-wrap gap-3">
                  <Link to={`/services/${s.id}`} className="btn-primary" data-testid={`services-detail-${s.id}`}>
                    View details <ArrowRight className="w-4 h-4" />
                  </Link>
                  <Link to="/book" className="btn-outline" data-testid={`services-book-${s.id}`}>Request this service</Link>
                </div>
              </div>
            </Reveal>
          ))}
        </div>

        <div className="mt-14 rounded-2xl bg-parchment-2 border border-[#F1E6D0] p-8 md:p-10 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
          <div>
            <h3 className="font-serif text-xl md:text-2xl text-espresso mb-2">Looking for a long-term nanny?</h3>
            <p className="text-sm text-stoneish max-w-xl">Full-time and long-term placements are handled by our sister service.</p>
          </div>
          <a href={BUSINESS.nannyUrl} target="_blank" rel="noreferrer" className="btn-accent shrink-0" data-testid="services-nanny-link">
            Explore nanny placements <ArrowRight className="w-4 h-4" />
          </a>
        </div>
      </section>
    </>
  );
}
